/* eslint-disable unicorn/filename-case */
import _ from 'lodash'
import moment from 'moment';

// US26648 TWIA Residential Quote Policy Details
const config = {
    // 2025-11-12 - Debra Frum - DE19606 - PE - TFPA : Unable to create future dated policy past 30 days even after changing the script parameter
    // Replace hard-coded frontend max effective date validation with use of backend DTO validation which uses script parameters to define the
    // max effective days in the future for each Association
    //
    // Removed hard-coded default which only applied to TWIA, but not TFPA.
    // Function setMaxEffectiveDays must be called to configure the max effective days in the future that applies to the Association when
    // creating quotes.
    maxEffectiveDays: 0
};

/** 
 * Trim to midnight
 * Hours, minutes, seconds and milliseconds to 0
 * @param srcDate
 * @return {Date}
 */
const trimToMidnight = (srcDate) => {
    const targetDate = _.cloneDeep(srcDate);

    targetDate.setHours(0, 0, 0, 0);

    return targetDate;
};

/**
 * Start of day, one minute after midnight.
 *
 * @param srcDate
 */
const trimToBeginOfDay = (srcDate) => {
    if (srcDate) {
        const targetDate = _.cloneDeep(srcDate);

        targetDate.setHours(0, 0, 1, 0);

        return targetDate;
    }

    return srcDate;
};

/**
 * Add days to a date
 * @param srcDate
 * @param numberOfDays
 * @returns {Date}
 */
const addDays = (srcDate, numberOfDays) => {
    if (_.isDate(srcDate) && _.isNumber(numberOfDays)) {
        return new Date(srcDate.getTime() + (1000 * 60 * 60 * 24 * numberOfDays));
    }

    return srcDate;
};

/**
 * End of day for a given date.
 *
 * @param srcDate
 * @returns {Date}
 */
const toEndOfDay = (srcDate) => {
    if (srcDate) {
        const targetDate = _.cloneDeep(srcDate);

        targetDate.setHours(23, 59, 59, 999);

        return targetDate;
    }

    return srcDate;
};

/**
 *
 * @param srcDate
 * @param minutes
 * @returns {Date}
 */
const addMinutes = (srcDate, minutes) => new Date(srcDate.getTime() + (minutes * 60 * 1000));

/**
 * Convert LocalDateDto to datetime.
 * @param localDate
 * @returns {Date}
 */
const localDateToDate = (localDate) => {
    const theDate = new Date();

    theDate.setHours(0, 0, 0, 0);
    theDate.setFullYear(localDate.year);
    theDate.setMonth(localDate.month);
    theDate.setDate(localDate.day);

    return theDate;
};

/**
 * Adds years to given date.
 * @param srcDate
 * @param years
 * @return {Date}
 */
const addYears = (srcDate, years) => {
    if (_.isDate(srcDate) && _.isNumber(years)) {
        const retDate = _.cloneDeep(srcDate);

        retDate.setFullYear(srcDate.getFullYear() + years);

        return retDate;
    }
    
    return srcDate;
};

/**
 * Parse date to LocalDateDto
 * @param theDate
 * @returns {{year: number, month: number, day: number}}
 */
const dateToLocalDate = (theDate) => ({
        year: theDate.getFullYear(),
        month: theDate.getMonth(),
        day: theDate.getDate()
    });

/**
 * Returns the year component of the date
 * @param theDate
 * @returns {number}
 */
const yearOfDate = (theDate) => theDate.getFullYear();

/**
 *  @param {number} days
 * DE10724  need to load Constants and set it to TWIADateUtil for EL Evaluation with new functions
 */
const setMaxEffectiveDays = (days) => {
    config.maxEffectiveDays = days;
};


/**
 *  @returns {number}
 * DE10724  need to load Constants and set it to TWIADateUtil for EL Evaluation with new functions
 */
const getMaxEffectiveDays = () => config.maxEffectiveDays;

/**
 *  @returns {Date}
 * DE10724  need to load Constants and set it to TWIADateUtil for EL Evaluation with new functions
 */
const getMaxEffDate = () => moment().add(config.maxEffectiveDays, 'days');

// DE12360 - Adding days from today function to support defect.
const daysFromToday = (srcDate) => moment(srcDate).diff(moment().startOf('day'), 'day');

/**
 * DE10724  need to load Constants and set it to TWIADateUtil for EL Evaluation with new functions
 */
export default {
    'addMinutes': (srcDate, minutes) => addMinutes(srcDate, minutes),
    'addDays': (srcDate, days) => addDays(srcDate, days),
    'addYears': (srcDate, years) => addYears(srcDate, years),
    'trimToMidnight': srcDate => trimToMidnight(srcDate),
    'trimToBeginOfDay': (srcDate) => trimToBeginOfDay(srcDate),
    'toEndDay': (srcDate) => toEndOfDay(srcDate),
    'beginOfBusinessDay': () => trimToBeginOfDay(new Date()),
    'beginOfToday': () => trimToMidnight(new Date()),
    'addDaysToBeginOfToday': numberOfDays => addDays(trimToBeginOfDay(new Date()), numberOfDays),
    'localDateToDate': (aLocalDate) => localDateToDate(aLocalDate),
    'dateToLocalDate': (aDate) => dateToLocalDate(aDate),
    'yearOfDate': (aDate) => yearOfDate(aDate),
    'daysFromToday': (srcDate) => daysFromToday(srcDate),
    setMaxEffectiveDays,
    getMaxEffectiveDays,
    getMaxEffDate
};
